export default __webpack_public_path__ + "static/Banner_reciclare_1200x900-a281b3df18608bd7845946f1b4c4f987.jpg";